import {NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MatInputModule, MatButtonModule} from '@angular/material';
import { ChangePassRoutingModule } from './change-password.routing';
import { ChangePasswordComponent } from './change-password.component';
import { SharedModule } from '../../shared/shared.module';
@NgModule({
  declarations: [
    ChangePasswordComponent
  ],
  imports: [ChangePassRoutingModule, SharedModule, ReactiveFormsModule, FormsModule, CommonModule, MatButtonModule],
  providers: [],
  bootstrap: []
})
export class ChangePassModule {
}




// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/change-password/change-password.module.ts